<template>
  <div v-if="invitation" class="im-invite-message">
    <div class="content">
      <div class="border">
        <div class="avatar-wrap">
          <img :src="avatar" class="avatar" @error="onError" />
        </div>
      </div>
      <div class="info">
        <div class="name">
          <span class="text">{{ name }}医生</span>
        </div>
        <div class="intro">
          邀请您
          <span class="span">视频通话</span>
          哦～
        </div>
      </div>
      <div class="btn" @click="onJoin">进入视频</div>
    </div>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex'
export default {
  name: 'imInviteMessage',
  props: {
    avatar: {
      type: String,
      default: ''
    },
    name: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      defaultAvatar: 'https://pharmacyimg.docbook.com.cn/mini_patient/default-photo.jpg' // 医生
    }
  },
  computed: {
    ...mapState('IM', ['invitation'])
  },
  methods: {
    ...mapMutations('IM', ['SET_CALL_STATUS']),
    onError() {
      return this.defaultAvatar
    },
    onJoin() {
      this.$emit('to', this.invitation)
    }
  }
}
</script>

<style lang="scss" scoped>
.im-invite-message {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3200;
  background: rgba(0, 0, 0, 0.4);
  display: flex;
}
.content {
  margin: auto;
  position: relative;
  padding: 1.024rem 0.32rem;
  background: #ffffff;
  border-radius: 0.341333rem;
  z-index: 20;

  .border {
    margin: 0 auto;
    width: 4.778667rem;
    height: 4.778667rem;
    border: 0.426667rem solid rgba(0, 137, 255, 0.14);
    border-radius: 4.778667rem;

    .avatar-wrap {
      border: 0.426667rem solid rgba(0, 137, 255, 0.2);
      width: 3.925333rem;
      height: 3.925333rem;
      border-radius: 3.968rem;
    }

    .avatar {
      display: block;
      width: 3.925333rem;
      height: 3.925333rem;
      border-radius: 3.968rem;
    }
  }

  .info {
    margin: 0.853333rem auto 0;
    font-size: 0.810667rem;
    line-height: 1.109333rem;
    color: #888888;
    text-align: center;

    .name {
      color: #0089ff;

      & > .text {
        display: block;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }

    .span {
      color: #0089ff;
    }
  }

  .btn {
    margin: 1.024rem auto 0;
    width: 10.752rem;
    height: 1.877333rem;
    font-size: 0.682667rem;
    line-height: 1.877333rem;
    box-shadow: 0rem 0rem 0.426667rem 0rem #ececec;
    border-radius: 0.938667rem;
    background: #0089ff;
    color: #ffffff;
    text-align: center;
  }
}
</style>
